import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WarningDialogComponent } from '../../warning-dialog/warning-dialog.component';
import { EmploymentType, TEMPORARY_EMPLOYMENT_TYPES_NUMS } from 'src/app/models/enums/employment-type-enum';

@Injectable({
  providedIn: 'root',
})
export class CheckEmploymentHistoryDialogService {
  private dialog = inject(MatDialog);


  checkAndOpenModal(employmentTypeId: EmploymentType | number): MatDialogRef<WarningDialogComponent> | null {
    const typeId = Number(employmentTypeId);

    if (TEMPORARY_EMPLOYMENT_TYPES_NUMS.has(typeId)) {
      return this.openModal();
    }

    return null;
  }

  private openModal(): MatDialogRef<WarningDialogComponent> {
    const dialogRef = this.dialog.open(WarningDialogComponent, {
      disableClose: false,
      data: {
        message: 'CheckEmploymentHistoryDialog.Message',
        closeButtonLabel: 'CheckEmploymentHistoryDialog.CloseButton',
      },
    });

    return dialogRef;
  }
}
